import { FlashMessageDto } from "src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto";
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState, UIDataModel } from "../../../../toolkit/uicomponent";
import { UIComponentView } from "../../../../toolkit/uicomponentview";
import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { UIComponentCSSStyle } from "../../../../toolkit/uicomponentcss";
import { APIFeatures } from "src/com/sixdee/crbtportal/core/util/apifeatures";
import { FlashMessageCardCSSStyle } from "./flashmessagecardcss";
import { FlashMessageCardViewImpl } from "./flashmessagecardview";

export interface FlashMessageCardComponentProps extends UIComponentProps
{

    flashMessageDto: FlashMessageDto;
    position: number;
    cardStyle :FlashMessageCardCSSStyle;
    onSetNow(flashMessageDto: FlashMessageDto):void;
}

export interface FlashMessageCardComponentState extends UIComponentState
{
   isHovered: boolean;
   isActionHovered: boolean;
}

export interface FlashCardComponentHandler extends UIComponentHandler
{
    onHovered():void;
    onDeleteClicked(): void;
    onHoveredExit():void;
    onActionHovered():void;
    onActionHoveredExit():void;
}

export class FlashMessageCardComponent extends UIComponentImpl<FlashMessageCardComponentProps, FlashMessageCardComponentState, UIDataModel> implements FlashCardComponentHandler
{
    constructor(props: FlashMessageCardComponentProps)
    {
        super(props);
        this.state = {isHovered: false, isActionHovered: false};
    }

    componentDidMount()
    {
        
    }
    UNSAFE_componentWillReceiveProps(nextProps: FlashMessageCardComponentProps)
    {
        
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new FlashMessageCardViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return this.props.cardStyle;
    }

    // protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    // {
    //      return new FlashMessageCardAPIModelImpl(applicationContext, apiModelHandler);
    // }

    componentWillReceiveProps(nextProps: FlashMessageCardComponentProps)
    {
    }

   

    onHovered(): void {
        this.setState({isHovered: true, isActionHovered: false});
    }

    onHoveredExit(): void {
        this.setState({isHovered: false, isActionHovered: false});
    }

    onActionHovered(): void 
    {
        this.setState({isHovered: false}, ()=>
        {
            this.setState({isActionHovered: true});
        });
    }

    onActionHoveredExit(): void {
        this.setState({isActionHovered: false, isHovered: true});
    }
  
    onDeleteClicked(): void 
    {
        // (this.getView() as ToneCardViewImpl).showLoader(); 
        // (this.getAPIModel() as ToneCardAPIModel).deleteTone(this.props.toneDto);
    }

   

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        // (this.getView() as ToneCardViewImpl).dismissLoader(); 
        // if(feature === APIFeatures.ADD_TO_WISHLIST)
        // {
        //     (this.getView() as ToneCardViewImpl).showPopup(this.getContext().getResources().getString(Strings.wishlist),this.getContext().getResources().getString(Strings.wishlist_add_order_is_successfully_completed),AlertType.SUCCESS);
        // }
        // else if(feature === APIFeatures.DELETE_FROM_WISHLIST)
        // {
        //     (this.getView() as ToneCardViewImpl).showPopup(this.getContext().getResources().getString(Strings.delete),this.getContext().getResources().getString(Strings.wishlist_delete_order_is_successfully_completed),AlertType.SUCCESS);
        // }
        // else
        // {
        //     (this.getView() as ToneCardViewImpl).showPopup(this.getContext().getResources().getString(Strings.delete),this.getContext().getResources().getString(Strings.your_order_is_successfully_completed),AlertType.SUCCESS);
        // }
    }
    
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        // (this.getView() as ToneCardViewImpl).dismissLoader(); 
        // if(feature === APIFeatures.ADD_TO_WISHLIST)
        // {
        //     (this.getView() as ToneCardViewImpl).showPopup(this.getContext().getResources().getString(Strings.wishlist),description,AlertType.ERROR);

        // }
        // else
        // {
        //     (this.getView() as ToneCardViewImpl).showPopup(this.getContext().getResources().getString(Strings.delete),description,AlertType.ERROR);
        // }
    }  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/flashmessagecard/flashmessagecardcomponent.tsx